export default __webpack_public_path__ + "static/media/avatar-s-9.e2785e7a.jpg";